var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Button, H3, Icon, P, Text } from '@a-type/ui';
import { graphql, useQuery } from '@biscuits/graphql';
import { Link } from '@biscuits/client';
import { useEffect } from 'react';
import { CopyTextbox, useAppId } from '../index.js';
const validateRouteQuery = graphql(`
	query ValidateRoute($input: GetDomainRouteByAppInput!) {
		domainRoute(byApp: $input, validate: true) {
			id
			status
			domain
			note
			mainRecord {
				name
				value
				type
			}
		}
	}
`);
export function DomainRouteValidation(_a) {
    var _b, _c, _d, _e, _f, _g;
    var { resourceId } = _a, rest = __rest(_a, ["resourceId"]);
    const appId = useAppId();
    const { data, error, refetch, loading } = useQuery(validateRouteQuery, {
        variables: {
            input: {
                appId,
                resourceId,
            },
        },
        onCompleted: (data) => {
            var _a, _b;
            if (((_a = data === null || data === void 0 ? void 0 : data.domainRoute) === null || _a === void 0 ? void 0 : _a.status) === 'READY') {
                (_b = rest.onValidated) === null || _b === void 0 ? void 0 : _b.call(rest);
            }
        },
    });
    const status = (_b = data === null || data === void 0 ? void 0 : data.domainRoute) === null || _b === void 0 ? void 0 : _b.status;
    const mainRecord = (_c = data === null || data === void 0 ? void 0 : data.domainRoute) === null || _c === void 0 ? void 0 : _c.mainRecord;
    const note = (_d = data === null || data === void 0 ? void 0 : data.domainRoute) === null || _d === void 0 ? void 0 : _d.note;
    useEffect(() => {
        if (status === 'TLS_SETUP' || status === 'MAIN_RECORD_SETUP') {
            const interval = setInterval(() => {
                refetch();
            }, 15000); // Refetch every 15 seconds
            return () => clearInterval(interval);
        }
    }, [status, refetch]);
    return (_jsxs(Box, Object.assign({ col: true, items: "start", gap: true }, rest, { children: [!!error && (_jsxs(Box, { gap: true, items: "center", surface: true, color: "attention", p: true, children: [_jsx(Icon, { name: "warning" }), _jsx("span", { children: "Failed to refresh validation status. Please try again in a bit." })] })), status === 'READY' ?
                _jsxs(Box, { surface: true, color: "accent", p: "lg", col: true, gap: true, items: "start", children: [_jsxs(Box, { gap: true, items: "center", children: [_jsx(Icon, { name: "check" }), _jsx("strong", { children: "Success" })] }), _jsxs(P, { children: [((_e = data === null || data === void 0 ? void 0 : data.domainRoute) === null || _e === void 0 ? void 0 : _e.domain) ?
                                    _jsx(Link, { to: `https://${data.domainRoute.domain}`, className: "font-bold", children: data.domainRoute.domain })
                                    : _jsx("strong", { children: "This domain" }), ' ', "has been validated. If it's not working right, try deleting it and adding it again."] }), _jsx(Button, { size: "small", onClick: () => refetch(), loading: loading, children: "Check again" })] })
                : status === 'TLS_SETUP' ?
                    _jsxs(_Fragment, { children: [_jsx(H3, { children: "Waiting for your certificates..." }), _jsx(P, { children: "Our provider is verifying your domain ownership and generating TLS certificates for you, which keeps your site visitors safe. This can take a few minutes." }), _jsx(Button, { onClick: () => refetch(), loading: loading, emphasis: "primary", children: "Check again now" })] })
                    : _jsxs(_Fragment, { children: [_jsxs(H3, { children: ["Add your DNS record for ", (_g = (_f = data === null || data === void 0 ? void 0 : data.domainRoute) === null || _f === void 0 ? void 0 : _f.domain) !== null && _g !== void 0 ? _g : '...'] }), _jsx(P, { children: "To validate your domain, add the following DNS record in your domain provider's dashboard:" }), mainRecord && _jsx(DnsRecord, Object.assign({}, mainRecord)), _jsxs(Box, { col: true, gap: true, items: "start", children: [note && (_jsx(Box, { surface: true, color: "primary", p: true, children: note })), _jsx(P, { children: "It can take up to 24 hours for your changes to take effect. Return to this menu any time to recheck your configuration." }), _jsx(Button, { onClick: () => refetch(), loading: loading, emphasis: "primary", children: "Check again now" })] })] })] })));
}
function DnsRecord({ type, name, value, verified, }) {
    return (_jsxs(Box, { surface: true, color: verified ? 'success' : undefined, container: true, border: true, gap: true, p: "lg", col: true, children: [verified && (_jsx(Icon, { name: "check", style: {
                    position: 'absolute',
                    top: 'var(--m-sp-sm)',
                    right: 'var(--m-sp-sm)',
                    color: 'var(--m-tint)',
                } })), _jsxs(Box, { gap: true, children: [_jsx(Text, { italic: true, children: "Type:" }), _jsx("span", { children: type })] }), _jsxs(Box, { col: true, gap: true, children: [_jsx(Text, { italic: true, children: "Name:" }), _jsx(CopyTextbox, { value: name, hideShare: true })] }), _jsxs(Box, { col: true, gap: true, children: [_jsx(Text, { italic: true, children: "Target:" }), _jsx(CopyTextbox, { value: value, hideShare: true })] })] }));
}
//# sourceMappingURL=DomainRouteValidation.js.map